<!-- 教育局 区级-材料管理 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>
		<div class="Homeboxtop_nav_tab">
			<span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName }]" :key="index+'sh_state'" @click="tabClick(item)">
				{{ item.name }}
			</span>
		</div>
        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.mname" placeholder="请输入材料名称"></el-input>
                </el-form-item>
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.oname" placeholder="请输入报审单位名称"></el-input>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="基本信息" align="center">
						<template slot-scope="scope">
							<img :src="scope.row.coverUrl" alt="" style="width: 58px;">
						</template>
                    </el-table-column>
					<el-table-column prop="mname" label="材料名称" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="useStartEndTime" label="材料使用期限" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="operateOrgName" label="报审单位" show-overflow-tooltip align="center">
                    </el-table-column>
					<el-table-column prop="price" label="材料定价" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<p>￥{{scope.row.price}}</p>
						</template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex" :type="detail_type"  @to-init="getDataList"></Detail>
</div>
</template>
<script>
import educationApi from '@/api/education/index.js';
import { handleMaterialsDetail, getAuditrecordList } from "@/api/mechanismApi/curriculum";
export default {
    components:{
        Detail: ()=>import('../materialCheck/detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				mname: '',
				oname:'',
			},
			shList:[],
			tableData: [],
            detail:{
                info:{},
                show:false,
            },
			tabList: [{name:'待审核'},{name:'审核通过'},{name:'审核不通过'}],
			tabName:'待审核',
			auditStateObj:{
				'待审核':'1',
				'审核通过':'2',
				'审核不通过':'3',
			},
			typeList:JSON.parse(sessionStorage.getItem('courseType')) || [],
			detail_type:'handle',
		}
	},
	watch:{
		tabName(n,o){
			this.pageNum=1;
			this.getDataList();
		}
	},
	created() {
		this.getDataList();
	},
	methods: {
		tabClick(item){
			this.tabName=item.name;
		},
		async getDataList() {
			let auditState=this.auditStateObj[this.tabName];
			let params = {
				mname:this.queryParams.mname,
				oname:this.queryParams.oname,
				pageNum:this.pageNum,
				pageSize:this.pageSize,
				auditState:auditState,
			}
			let res = await educationApi.getEducationMaterialsMannagelist(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			let params = {
				mid: item.mid,
			};
			var { result, data } = await handleMaterialsDetail(params);
			let res= await getAuditrecordList({ mid: item.mid,});
			if (result == "000000") {
				this.detail.info = data;
				if(res.result==='000000'){
					this.detail.info.operateList=res.data || [];
				}
				this.detail_type=this.tabName==='待审核'?'handle':'manager';
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
        toIndex(){
            this.detail.show=false;
        },
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 160px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
.m-l{
	margin-left: 20px;
}
.res-tab{
	padding-bottom: 15px;
}
</style>
